import Marquee3k from 'marquee3000'

const $logos = document.querySelector('.partners-logos-wrapper')

const fn = {
  init: () => {
    Marquee3k.init()
  },
}

export default {
  can: () => $logos,
  run: fn.init,
}
